export default "__VITE_ASSET__BOByi5L9__"